/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorIcon16Regular = forwardRef('TechScreenMonitorIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 2A2.75 2.75 0 0 0 1 4.75v4.5A2.75 2.75 0 0 0 3.75 12h2v1.5h-1a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-1V12h2A2.75 2.75 0 0 0 15 9.25v-4.5A2.75 2.75 0 0 0 12.25 2h-8.5Zm5 10h-1.5v1.5h1.5V12ZM2.5 4.75c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25v-4.5Z" })));
});
